import {Component, Input} from '@angular/core';
import {FilterModelDto} from "../../../../models/filter.model";

@Component({
  selector: 'app-virtual-cash-page-filter',
  templateUrl: './virtual-cash-page-filter.component.html',
  styleUrls: ['./virtual-cash-page-filter.component.scss']
})
export class VirtualCashPageFilterComponent {
  @Input() filterStatuses: FilterModelDto[] | undefined
  @Input() filterP2p: FilterModelDto[] | undefined
  @Input() filterCurrency: FilterModelDto[] | undefined
}
